import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import StarIcon from "@mui/icons-material/Star";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Toaster, toast } from "react-hot-toast";
import { UnifiedTaskTable } from "./UnifiedTaskTable.jsx";
import Tooltip from "@mui/material/Tooltip";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { FeedbackTable } from "./FeedbackTable";
import moment from "moment";
import { colors } from "../../../../Shared/colors";
import { useAddtelesaleLeadTaskMutation } from "../../../../features/telesaletaskSlice";
import { useAddFavouriteTelesalesleadMutation, useRemoveFavouriteTelesalesleadMutation } from "../../../../features/telesaleleadsSlice";

export const SearchLeadsDataTable = ({ leads, refetch, currentPage, pageSize, setPageSize, setPage, isFetching, handleCheckboxChange, checked }) => {

  const [popUp, setpopUp] = useState(false);
  const [leadId, setleadId] = useState("");
  const [leadNumber, setLeadNumber] = useState("");
  const [multileadId, setmultileadId] = useState([]);
  const [addTask, { isLoading }] = useAddtelesaleLeadTaskMutation();
  const [taskPopUp, setTaskPopUp] = useState(false);
  const [feedbackPopup, setfeedbackPopup] = useState(false)
  const [feedbackData, setfeedbackData] = useState([])
  const [numberPopUp, setnumberPopUp] = useState(false);
  const [phoneData, setphoneData] = useState([]);
  const [minDate, setminDate] = useState("");
  const [maxDate, setmaxDate] = useState("")
  const [favouriteLoading, setfavouriteLoading] = useState(false);


  const [addFavouriteTelesaleslead] = useAddFavouriteTelesalesleadMutation();
  const [removeFavourite] = useRemoveFavouriteTelesalesleadMutation();


  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        setpopUp(false);
        setTaskPopUp(false);
        setnumberPopUp(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const today = moment();
  const defaultDate = today.format('YYYY-MM-DDTHH:mm');
  const newMinDate = today.clone().subtract(1, 'days').format('YYYY-MM-DDTHH:mm');

  useEffect(() => {
    setminDate(newMinDate);
  }, [newMinDate]);

  useEffect(() => {
    setmaxDate(defaultDate);
  }, [defaultDate]);

  const [task, settask] = useState({
    currentTaskType: "",
    currentSubTypeTask: "",
    completedDate: defaultDate,
    reason: "",
    comment: "",
    nextTaskType: "",
    deadline: "",
    attachment: "",

  });


  let handleChange = (e) => {
    const { name, value } = e.target;

    settask((prevTask) => ({
      ...prevTask,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    settask((prevstate) => ({
      ...prevstate,
      [name]: e.target.files[0],
    }));
    e.target.value = '';
  };

  const handleType = (e) => {
    handleChange(e);
  };

  const handleSubtype = (e) => {
    handleChange(e);
  };

  const handleSave = () => {
    // Prevent multiple submissions
    if (isLoading) {
      return;
    }

    // Frontend validations
    if (!task.currentTaskType) {
      return toast.error("Please select current task type");
    }
    if (!task.currentSubTypeTask) {
      return toast.error("Please select current sub type");
    }
    if (!task.nextTaskType) {
      return toast.error("Please select next task");
    }
    if (task.currentTaskType.toLowerCase() === 'call' && task.currentSubTypeTask.toLowerCase() === 'whatsapp' && !task.attachment) {
      return toast.error("Whatsapp proof image is required");
    }

    // Check if we need to send FormData (when there's a file attachment)
    const isWhatsapp = task.currentTaskType.toLowerCase() === 'call' && task.currentSubTypeTask.toLowerCase() === 'whatsapp';

    let requestPromise;

    if (isWhatsapp && task.attachment) {
      // Use FormData for file upload
      const formData = new FormData();
      formData.append('assignmentID', task.assignmentID);
      formData.append('leadID', task.leadId);
      formData.append('telesalesEmployeeID', task.telesalesEmployeeID);
      formData.append('originalEmployeeID', task.originalEmployeeID);
      formData.append('currentTaskType', task.currentTaskType);
      formData.append('currentSubTypeTask', task.currentSubTypeTask);
      formData.append('comment', task.comment);
      formData.append('nextTaskType', task.nextTaskType);
      formData.append('deadline', task.deadline);
      formData.append('attachment', task.attachment);

      requestPromise = addTask(formData);
    } else {
      // Use regular JSON payload for non-file uploads
    const payload = {
      assignmentID: task.assignmentID,
      leadID: task.leadId,
      telesalesEmployeeID: task.telesalesEmployeeID,
      originalEmployeeID: task.originalEmployeeID,
          currentTaskType: task.currentTaskType || "",
          currentSubTypeTask: task.currentSubTypeTask || "",
          comment: task.comment || "",
      nextTask: {
        nextTaskType: task.nextTaskType || "",
        deadline: task.deadline || ""
      },
    };

      requestPromise = addTask(payload);
    }

    requestPromise
      .unwrap()
      .then((res) => {
        toast.success("task created successfully");
        settask({
          currentTaskType: "",
          currentSubTypeTask: "",
          completedDate: defaultDate,
          reason: "",
          assignmentID: "",
          comment: "",
          nextTaskType: "",
          deadline: "",
          attachment: "",
          leadId: task.leadId,
        });
        setpopUp(false);
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message || "Something went wrong");
      });
  };
  // const handleAddFavourite = (id) => {
  //   setfavouriteLoading(true);

  //   addFavouriteTelesaleslead(id)
  //     .unwrap()
  //     .then((res) => {
  //       toast.success("Added to favourite");
  //       setfavouriteLoading(false);
  //     })
  //     .catch((error) => {
  //       toast.error(error.data?.message || "Something went wrong");
  //       setfavouriteLoading(false);
  //     });
  // };
  const handleToggleFavourite = async (id, isFav) => {
    setfavouriteLoading(true);
    try {
      if (isFav) {
        await removeFavourite(id).unwrap();
        toast.success("Removed from favourites");
      } else {
        await addFavouriteTelesaleslead(id).unwrap();
        toast.success("Added to favourites");
      }
      await refetch();
    } catch (err) {
      toast.error(err?.data?.message || "Something went wrong");
    } finally {
      setfavouriteLoading(false);
    }
  };

  useEffect(() => {
    if (taskPopUp || popUp || numberPopUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [taskPopUp, popUp, numberPopUp]);


  const columns = [
    {
      field: "client",
      headerName: "Client",
      width: 150,
      renderCell: (params) => {
        const id = params.row.telesaleleadid;

        return (
          <Client>
            <Tooltip title={params.row.client}>
              <div>{params.row.client}</div>
            </Tooltip>
            <div>
              {params.row.favourite ? (
                <Tooltip title="Remove from favourite">
                <StarIcon
                  sx={{
                      color: colors.starYellow,
                      fontSize: "small",
                      cursor: "pointer",
                    }}
                    onClick={() => handleToggleFavourite(id, true)}
                  />
                </Tooltip>

              ) : (
                <Tooltip title="Add to favourite">
                <StarBorderIcon
                  sx={{
                      color: colors.starYellow,
                      fontSize: "small",
                      cursor: "pointer",
                    }}
                    onClick={() => handleToggleFavourite(id, false)}
                  />
                </Tooltip>

              )}

              <span>
                Lead
                {params.row.isNew && (
                  <span
                    style={{
                      backgroundColor: "#249393",
                      color: "white",
                      fontSize: "10px",
                      padding: "0 2px",
                      marginLeft: "5px",
                      borderRadius: "3px",
                    }}
                  >
                    New
              </span>
                )}
              </span>
            </div>
          </Client>
        );
      },
    }
    ,
    {
      field: "leadId",
      headerName: "Lead ID",
      width: 150,
      renderCell: (params) => {
        return params.row.classification === "veryHot" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.veryHot}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "hot" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.hot}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "moderate" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.moderate}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "cold" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.cold}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.veryCold}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        );
      },
    },
    {
      field: "source",
      headerName: "Source",
      width: 150,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
      valueGetter: (params) => params.row.primaryPhone || "",
      renderCell: (params) => {
        const numbers = params.row.phone || [];
        const first = params.row.primaryPhone || "";
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {numbers.length > 1 ? (
              <button
                onClick={() => {
                  setphoneData(numbers);
                  setnumberPopUp(true);
                }}
                style={{
                  width: "100%",
                  backgroundColor: `${colors.brown}`,
                  color: `${colors.white}`,
                  padding: "0.5em 0em",
                  cursor: "pointer",
                  borderRadius: "5px",
                  border: `1px solid ${colors.inputBorderWhite}`,
                }}
              >
                {first}
              </button>
            ) : first ? (
              <a href={`tel:+${first}`}>{first}</a>
            ) : (
              <span style={{ color: '#999' }}>No Phone</span>
            )}
          </div>
        );
      },
    },
    {
      field: "feedback",
      headerName: "Feedback",
      width: 110,
      renderCell: (params) => {
        return (
          <>
            {
              params.row?.feedback?.length > 0 ?
                <Feedback>
                  <button onClick={() => {
                    setfeedbackPopup(true)
                    setfeedbackData(params.row.feedback)
                  }}>View Feedback</button>
                </Feedback> : "No Feedback"
            }
          </>
        );
      },
    },
    {
      field: "project",
      headerName: "Project",
      width: 110,
      renderCell: (params) => {
        return (
          <div
            style={{
              color: colors.textBlue,
              cursor: 'pointer',
              padding: '4px 8px',
              border: '1px solid transparent',
              borderRadius: '4px',
            }}
          >
            {params.row.project}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 180,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        const whatsappLink = `https://wa.me/${params.row.cellNo}`

        return (
          <Action>
            <div
              onClick={() => {
                settask({
                  ...task,
                  leadId: params.row.telesaleleadid,
                  assignmentID: params.row.id,
                  telesalesEmployeeID: params.row.telesalesEmployeeID,
                  originalEmployeeID: params.row.originalEmployeeID,
                  telesalesEmployeeName: params.row.telesalesEmployeeName,
                  clientId: params.row.clientId,
                  clientname: params.row.client,
                  phoneNo: params.row.cellNo,
                  leadStatus: params.row.leadstatus,
                })
                setpopUp(true)
              }}
            >
              <img src="/assets/icons/plus.png" alt="plus" />
            </div>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
            >
              <WhatsAppIcon style={{ color: "green", cursor: "pointer" }} />
            </a>
            <Tooltip
              title={
                <div style={{ padding: '8px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Latest Task:</div>
                  <div><strong>Sub Type:</strong> {params.row.latestTaskSubType || 'N/A'}</div>
                  <div><strong>Comment:</strong> {params.row.latestTaskComment || 'N/A'}</div>
                </div>
              }
              placement="top"
              arrow
            >
            <RemoveRedEyeIcon
              style={{ color: `${colors.brown}`, cursor: "pointer" }}
              onClick={() => {
                setTaskPopUp(true)
                setleadId(params.row.telesaleleadid)
                  setLeadNumber(params.row.leadId)
              }}
            />
            </Tooltip>
          </Action>
        )
      },
    }

  ];
  let rows = [];

  // Debug: Log leads data
  // console.log("🔍 DataTable - leads prop:", leads);
  // console.log("🔍 DataTable - assignments:", leads?.assignments);

  (leads?.assignments || []).forEach((lead) => {
    rows.push({
      id: lead._id,
      telesaleleadid: lead.leadID?._id,
      leadId: lead.leadID?.leadID,
      leadstatus: lead.leadID?.leadStatus,
      client: lead.leadID?.clientID?.fullName,
      clientId: lead.leadID?.clientID?._id,
      phone: lead.leadID?.clientID?.cellNo,
      primaryPhone: (lead.leadID?.clientID?.cellNo && lead.leadID?.clientID?.cellNo.length > 0) ? lead.leadID?.clientID?.cellNo[0]?.phoneNo : "",
      project: lead.leadID?.leadOpportunity?.project?.projectName,
      projectId: lead.leadID?.leadOpportunity?.project?._id,
      classification: lead.leadID?.leadOpportunity?.classification,
      source: lead.leadID?.leadOpportunity?.source,
      allocatedto: lead.telesalesEmployeeID?.firstName,
      favourite: lead?.favourite,
      // Show "New" only until the TS agent adds their first task on this lead.
      isNew: !lead?.latestTaskType,
      status: lead?.status,
      assignmentDate: lead?.assignmentDate,
      originalEmployeeID: lead?.originalEmployeeID?._id,
      telesalesEmployeeID: lead?.telesalesEmployeeID?._id,
      telesalesEmployeeName: `${lead?.telesalesEmployeeID?.firstName || ""} ${lead?.telesalesEmployeeID?.lastName || ""}`.trim(),
      // Latest task information for tooltip
      latestTaskType: lead?.latestTaskType || null,
      latestTaskSubType: lead?.latestTaskSubType || null,
      latestTaskComment: lead?.latestTaskComment || null,
      latestTaskDate: lead?.latestTaskDate || null,

    });
  });


  return (
    <Main>
      <LeadsSection>
        <div>
          <div className="lead-count">
            Total Leads: <span>{leads?.total || 0}</span>
          </div>
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleCheckboxChange}
                sx={{
                  color: colors.brown,
                  '&.Mui-checked': {
                    color: colors.brown,
                  },
                }}
              />
            }
            label={
              <div className="new-leads-indicator">
                <span>Assigned New Leads</span>
                {leads?.leadID?.leadStatus && <div className="blink-dot"></div>}
              </div>
            }
          /> */}
        </div>
      </LeadsSection>
      <Table>
        {rows.length > 0 ? (
          <DataGrid
            key={`${currentPage}-${pageSize}`}
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            page={currentPage - 1}
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize);
              setPage(1);
            }}
            onPageChange={(newPage) => setPage(newPage + 1)}
            rowsPerPageOptions={[10, 20, 50, 100]}
            checkboxSelection
            onSelectionModelChange={(LeadIDs) => {
              setmultileadId(LeadIDs);
            }}
            pagination
            paginationMode="server"
            loading={isFetching}
            loadingOverlay={isFetching ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '200px',
                gap: '1.5rem',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%)',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{
                  position: 'relative',
                  width: '50px',
                  height: '50px'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    border: '4px solid rgba(36, 147, 147, 0.1)',
                    borderTop: '4px solid #249393',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    width: '34px',
                    height: '34px',
                    border: '2px solid rgba(36, 147, 147, 0.2)',
                    borderTop: '2px solid #1a6b6b',
                    borderRadius: '50%',
                    animation: 'spin 1.5s linear infinite reverse'
                  }} />
                </div>
                <div style={{
                  textAlign: 'center',
                  color: '#249393',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    {isFetching ? 'Searching leads...' : 'Loading leads...'}
                  </div>
                  <div style={{
                    fontSize: '0.85rem',
                    color: '#64748b',
                    fontWeight: '400'
                  }}>
                    Please wait while we fetch your data
                  </div>
                </div>
              </div>
            ) : undefined}
            rowCount={leads?.total || 0}
            autoHeight
            sx={{
              border: "1px solid #e0e0e0",
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              },
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #f0f0f0',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #e0e0e0',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f8f9fa',
              },
            }}
          />
        ) : (
          <EmptyState>
            <div className="empty-icon">📊</div>
            <h3>No Leads Found</h3>
            <p>
              {isFetching
                ? "Loading leads..."
                : "No leads match your current search criteria. Try adjusting your filters or search again."
              }
            </p>
          </EmptyState>
        )}
        {/* {favouriteLoading ? <Loader /> : null} */}
      </Table>
      {feedbackPopup && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Cross onClick={() => setfeedbackPopup(!feedbackPopup)} style={{ height: "3%" }}>
              <img src="/assets/icons/cross.png" alt="cross" />
            </Cross>
            <PopUpSection style={{ height: "90%" }}>
              <FeedbackTable feedback={feedbackData} />
            </PopUpSection>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}

      {popUp && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Cross
              onClick={() => {
                settask({
                  currentTaskType: "",
                  currentSubTypeTask: "",
                  completedDate: defaultDate,
                  subType: "",
                  reason: "",
                  comment: "",
                  nextTaskType: "",
                  deadline: "",
                  attachment: "",
                  leadId: task.leadId,
                });
                setpopUp(false);
              }}
            >
              <img src="/assets/icons/cross.png" alt="cross" />
            </Cross>
            <PopUpSection>
              <Section>
                <Task>
                  <Heading>Current Task</Heading>
                  <InputPart>
                    <InputFeild>
                      <h3>
                        Type:<b style={{ color: "red" }}>*</b>
                      </h3>
                      <div>
                        <select
                          name="currentTaskType"
                          id="currentTaskType"
                          value={task.currentTaskType}
                          onChange={handleType}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          <option value="call">Call</option>
                        </select>
                      </div>
                    </InputFeild>
                    <InputFeild>
                      <h3>Sub-Type:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        {/* <select
                          name="currentSubTypeTask"
                          id="currentSubTypeTask"
                          value={task.currentSubTypeTask}
                          onChange={handleSubtype}
                        >
                          <option value=""  >Select</option>
                          {subType?.map((ls) => (
                            <option value={ls} key={ls}>
                              {ls}
                            </option>
                          ))}
                        </select> */}
                        <select
                          name="currentSubTypeTask"
                          id="currentSubTypeTask"
                          value={task.currentSubTypeTask || ""}
                          onChange={handleSubtype}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          <option value="Call connected">Call Connected</option>
                          <option value="Call Not Connected">Call Not Connected</option>
                          <option value="followUp">Follow Up</option>
                          <option value="follow_up_sent">Follow Up Sent</option>
                          <option value="sms">SMS</option>
                          <option value="whatsapp">Whatsapp</option>
                          <option value="meeting_completed">Meeting Completed</option>
                        </select>

                      </div>
                    </InputFeild>
                    <InputFeild>
                      <h3>Completed Date:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <input
                          type="datetime-local"
                          name="completedDate"
                          id="completedDate"
                          value={task.completedDate || defaultDate}
                          onChange={handleChange}
                          min={newMinDate}
                          max={defaultDate}
                        />
                      </div>
                    </InputFeild>
                    <InputFeild>
                      <h3>Comment:<b style={{ color: "red" }}>*</b></h3>
                      <textarea
                        name="comment"
                        id="comment"
                        placeholder="type here..."
                        value={task.comment}
                        onChange={handleChange}
                      ></textarea>
                    </InputFeild>
                    {
                      task.currentTaskType === 'call' && task.currentSubTypeTask === "whatsapp" ?
                        <InputFeild>
                          <h3>Attachment (Picture Proof):<b style={{ color: "red" }}>*</b></h3>
                          <span>
                            <p>Upload WhatsApp screenshot/proof</p>
                            <label htmlFor="attachment">
                              <AttachFileIcon /> Upload
                            </label>
                            {task.attachment && (
                              <UploadedFile
                                src={URL.createObjectURL(task.attachment)}
                                alt="uploaded file"
                              />
                            )}
                          </span>
                          <input
                            type="file"
                            name="attachment"
                            id="attachment"
                            accept="image/*"
                            onChange={handleFileChange}
                          />
                        </InputFeild> : null}

                  </InputPart>
                </Task>
              </Section>
              <Section>
                <Task style={{ borderRight: "none" }}>
                  <Heading>Next Task</Heading>
                  <InputPart>
                    <InputFeild>
                      <h3>Next Task:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <select
                          name="nextTaskType"
                          id="nextTaskType"
                          value={task.nextTaskType || ""}
                          onChange={handleChange}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          <option value="meeting_schedule">Meeting Scheduled</option>
                          <option value="followUp">Follow Up</option>
                          <option value="meeting_reschedule">Reschedule Meeting</option>
                        </select>
                      </div>
                    </InputFeild>

                    <InputFeild>
                      <h3>Deadline:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <input
                          type="datetime-local"
                          name="deadline"
                          id="deadline"
                          value={task.deadline}
                          onChange={handleChange}
                          min={new Date().toISOString().slice(0, 16)}
                        />
                      </div>
                    </InputFeild>
                  </InputPart>
                </Task>
              </Section>
            </PopUpSection>
            <ButtonPart>
              <button
                className="cancel-btn"
                onClick={() => {
                  settask({
                    currentTaskType: "",
                    currentSubTypeTask: "",
                    completedDate: defaultDate,
                    subType: "",
                    reason: "",
                    comment: "",
                    nextTaskType: "",
                    deadline: "",
                    leadId: task.leadId,
                  });
                  setpopUp(false);
                }}
              >
                Cancel
              </button>
              <button
                className="save-btn"
                style={{
                  opacity: isLoading ? "0.5" : "1",
                }}
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? <>Saving...</> : <>Save</>}
              </button>
            </ButtonPart>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}
      {taskPopUp && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Crosstask
              onClick={() => setTaskPopUp(!taskPopUp)}
            >
              <img src="/assets/icons/cross.png" alt="cross" />
            </Crosstask>
            <PopUpSection className="task-table-section" style={{ height: "calc(100% - 80px)" }}>
              <UnifiedTaskTable leadID={leadId} leadNumber={leadNumber} />
            </PopUpSection>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}
      <PopUpContainer popUp={numberPopUp}>
        <NumberPopUp>
          <Cross
            onClick={() => setnumberPopUp(!numberPopUp)}
            style={{ height: "5%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <NumberPopUpSection style={{ height: "90%", overflowY: "scroll", paddingTop: "1em" }}>

            {phoneData.map((phone) => (
              <div>
                <span>Phone No: </span> <a href={`tel:+${phone.phoneNo}`}>{phone.phoneNo}</a>

              </div>
            ))}
          </NumberPopUpSection>
        </NumberPopUp>
      </PopUpContainer>



      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;
const LeadsSection = styled.div`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  
  > div {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
  
  .lead-count {
    font-size: 1.1rem;
    color: ${colors.text};
    font-weight: 600;
    
  span {
      color: ${colors.brown};
      font-weight: 700;
      font-size: 1.2rem;
    }
  }
  
  .new-leads-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: ${colors.textMed};
    
    .blink-dot {
      width: 8px;
      height: 8px;
      background-color: ${colors.brown};
      border-radius: 50%;
      animation: blink 1s infinite;
    }
  }
  
  @keyframes blink {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0.3; }
  }
`;
const Csvbutton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.textMed};
  background: ${colors.white};
  padding: 12px 16px;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  
  &:hover {
    border-color: ${colors.brown};
    color: ${colors.brown};
    background: ${colors.lightWhite};
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.15);
  }
  
  &:active {
  }
`
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: ${colors.white};
  background: ${(props) =>
    props.isDisabled
      ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
      : `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`};
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  font-size: 0.875rem;
  font-weight: 600;
  box-shadow: ${(props) =>
    props.isDisabled
      ? '0 2px 4px rgba(0, 0, 0, 0.1)'
      : '0 4px 12px rgba(36, 147, 147, 0.3)'};
  
  &:hover:not(:disabled) {
    box-shadow: 0 8px 20px rgba(36, 147, 147, 0.4);
    background: linear-gradient(135deg, #1a6b6b 0%, ${colors.brown} 100%);
  }
  
  &:active:not(:disabled) {
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Table = styled.div`
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
  
  .MuiDataGrid-root {
    border: none !important;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    background: ${colors.white};
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    }
  }
  
  .MuiDataGrid-main {
    border-radius: 16px;
  }
  
  .MuiDataGrid-columnHeaders {
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    border-bottom: 3px solid ${colors.inputBorderWhite};
    font-weight: 700;
    color: ${colors.text};
    min-height: 60px !important;
    
    .MuiDataGrid-columnHeaderTitle {
      font-weight: 700;
      font-size: 0.9rem;
      letter-spacing: 0.025em;
    }
  }
  
  .MuiDataGrid-columnHeader {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${colors.text};
    padding: 0 16px;
  }
  
  .MuiDataGrid-row {
    border-bottom: 1px solid ${colors.inputBorderWhite};
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    
    &.Mui-selected {
      background: linear-gradient(135deg, rgba(36, 147, 147, 0.1) 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      border-left: 4px solid ${colors.brown};
    }
    
    &:nth-of-type(even) {
      background: rgba(248, 249, 250, 0.5);
    }
  }
  
  .MuiDataGrid-cell {
    border: none !important;
    font-size: 0.85rem;
    color: ${colors.text};
    padding: 16px;
    display: flex;
    align-items: center;
    
    &:focus {
      outline: none;
    }
  }
  
  .MuiDataGrid-footerContainer {
    border-top: 2px solid ${colors.inputBorderWhite};
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    min-height: 70px;
    padding: 0 24px;
  }
  
  .MuiTablePagination-root {
    color: ${colors.textMed};
    font-weight: 500;
    
    .MuiTablePagination-selectLabel,
    .MuiTablePagination-displayedRows {
      font-weight: 600;
      color: ${colors.text};
    }
    
    .MuiTablePagination-select {
      border-radius: 8px;
      border: 1px solid ${colors.inputBorderWhite};
      padding: 4px 8px;
      
      &:hover {
        border-color: ${colors.brown};
      }
    }
  }
  
  .MuiCheckbox-root {
    color: ${colors.brown} !important;
    padding: 8px;
    
    &.Mui-checked {
      color: ${colors.brown} !important;
    }
    
    &:hover {
      background: rgba(36, 147, 147, 0.1);
      border-radius: 4px;
    }
  }
  
  // Custom scrollbar
  .MuiDataGrid-virtualScroller {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: ${colors.lightWhite};
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${colors.inputBorderWhite};
      border-radius: 4px;
      
      &:hover {
        background: ${colors.textMed};
      }
    }
  }
  
  @media (max-width: 768px) {
    padding: 1rem 2rem 2rem 2rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 50px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.8rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.8rem;
      padding: 0 12px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.8rem;
      padding: 12px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 60px;
      padding: 0 16px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 1rem 1rem 1rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 45px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.75rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.75rem;
      padding: 0 8px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.75rem;
      padding: 8px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 50px;
      padding: 0 12px;
    }
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
  border-radius: 20px;
  border: 2px dashed ${colors.inputBorderWhite};
  margin: 2rem 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(36, 147, 147, 0.05) 0%, transparent 70%);
    animation: float 6s ease-in-out infinite;
  }
  
  .empty-icon {
    font-size: 5rem;
    margin-bottom: 1.5rem;
    opacity: 0.8;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    animation: bounce 2s ease-in-out infinite;
    position: relative;
    z-index: 1;
  }
  
  h3 {
    color: ${colors.text};
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 1rem 0;
    position: relative;
    z-index: 1;
    background: linear-gradient(135deg, ${colors.text}, ${colors.brown});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    color: ${colors.textMed};
    font-size: 1.1rem;
    margin: 0;
    max-width: 450px;
    line-height: 1.6;
    position: relative;
    z-index: 1;
    font-weight: 500;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
  }
  
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-10px); }
    60% { transform: translateY(-5px); }
  }
`;

const Client = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }
`;

const Id = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: ${colors.textBlue};
  }
  p {
    color: ${colors.textMed};
  }
`;

const Action = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  gap: 0.75rem;
  padding: 8px;
  
  div {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
    border: 1px solid ${colors.inputBorderWhite};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.1) 100%);
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-color: ${colors.brown};
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
    
    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    }
  }
  
  .MuiSvgIcon-root {
    transition: all 0.3s ease;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    
    &:hover {
      transform: scale(1.1);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    }
  }
  
  // WhatsApp icon special styling
  .MuiSvgIcon-root[style*="green"] {
    &:hover {
      color: #25d366 !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(37, 211, 102, 0.3));
    }
  }
  
  // Eye icon special styling
  .MuiSvgIcon-root[style*="brown"] {
    &:hover {
      color: ${colors.brown} !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(36, 147, 147, 0.3));
    }
  }
`;

const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${(props) => (props.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  isolation: isolate;
`;

const PortalPopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  isolation: isolate !important;
  pointer-events: auto !important;
`;

const PopUp = styled.div`
  width: 95vw;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  overflow: hidden;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  /* Allow tooltips to appear above modal */
  .MuiDataGrid-root {
    z-index: 1 !important;
  }
  
  .MuiDataGrid-columnHeaders {
    z-index: 2 !important;
  }
  
  .MuiDataGrid-menuIcon {
    z-index: 3 !important;
  }
  
  .MuiDataGrid-columnHeaderTitle {
    z-index: 2 !important;
  }
  
  /* Ensure tooltips appear above modal */
  .MuiTooltip-popper {
    z-index: 9999 !important;
  }
`;
const NumberPopUp = styled.div`
  width: 90vw !important;
  max-width: 500px !important;
  height: auto !important;
  min-height: 500px !important;
  max-height: 85vh !important;
  overflow: hidden !important;
  background-color: ${colors.white} !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Cross = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;
const Crosstask = styled.div`
  position: absolute;
  top: 10px;
  right: 2px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;

const PopUpSection = styled.div`
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  flex: 1;
  overflow-y: auto;
  padding: 0;
  
  &.task-table-section {
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
  }
`;
const NumberPopUpSection = styled(PopUpSection)`
  flex-direction: column;
  margin: 1em;
  justify-content: center;
  line-height: 3em;
`;

const Section = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-right: 1px solid #e0e0e0;
  height: 100%;
  
  &:last-child {
    border-right: none;
  }
`;

const Task = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1.5rem;
`;

const Heading = styled.div`
  width: 100%;
  text-align: left;
  padding: 0 0 1rem 0;
  color: ${colors.textBlue};
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1.5rem;
`;

const InputPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }
`;

const InputFeild = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  h3 {
    color: ${colors.text};
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }
  p {
    color: ${colors.veryHot};
    margin-top: 0.5em;
  }
  div {
    position: relative;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    width: 100%;
    background-color: #f8f9fa;
    
    &:focus-within {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    select,
    input[type="date"] {
      background-color: transparent;
      width: 100%;
      padding: 12px 16px;
      outline: none;
      border: none;
      font-size: 0.95rem;
      color: ${colors.text};
      
      ::placeholder {
        color: #999;
      }
    }
  }
  input,
  textarea {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #f8f9fa;
    width: 100%;
    padding: 12px 16px;
    outline: none;
    font-size: 0.95rem;
    color: ${colors.text};
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    ::placeholder {
      color: #999;
    }
  }
  span {
    background-color: ${colors.inputWhite};
    padding: 1em 0em 1em 1em;
    border-radius: 5px;
    border: 1px solid ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    label {
      position: absolute;
      right: 3%;
      top: 20%;
      background-color: ${colors.black};
      color: ${colors.white};
      padding: 0.5em 1em;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: clamp(1em, 1vh, 2em);
      color: ${colors.textMed};
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  gap: 1rem;
  
  .cancel-btn {
    background: #6c757d;
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
    
    &:hover {
      background: #5a6268;
      box-shadow: 0 8px 20px rgba(108, 117, 125, 0.3);
    }
    
    &:active {
    }
  }
  
  .save-btn {
    background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
    
    &:hover {
      box-shadow: 0 8px 20px rgba(36, 147, 147, 0.3);
    }
    
    &:active {
    }
  }
`;

const UploadedFile = styled.img`
  border-radius: 50%;
  margin-left: 50%;
  width: 70px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Feedback = styled.div`
button{
  background-color: ${colors.brown};
  color: ${colors.white};
  border: none;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
}
`